// String values so a token is distinguishable from a raw number at runtime: only tokens resolve to the mobile-aware variable.
export var Spacing = /*#__PURE__*/ function(Spacing) {
    Spacing["Space0"] = "Space0";
    Spacing["Space2"] = "Space2";
    Spacing["Space4"] = "Space4";
    Spacing["Space8"] = "Space8";
    Spacing["Space12"] = "Space12";
    Spacing["Space16"] = "Space16";
    Spacing["Space20"] = "Space20";
    Spacing["Space24"] = "Space24";
    Spacing["Space32"] = "Space32";
    Spacing["Space40"] = "Space40";
    return Spacing;
}({});
const DESKTOP_PX = {
    ["Space0"]: 0,
    ["Space2"]: 2,
    ["Space4"]: 4,
    ["Space8"]: 8,
    ["Space12"]: 12,
    ["Space16"]: 16,
    ["Space20"]: 20,
    ["Space24"]: 24,
    ["Space32"]: 32,
    ["Space40"]: 40
};
const SPACING_TOKENS = new Set(Object.values(Spacing));
function isSpacingToken(value) {
    return typeof value === 'string' && SPACING_TOKENS.has(value);
}
export function spacingValue(value) {
    if (!isSpacingToken(value)) return value;
    const desktopPx = DESKTOP_PX[value];
    return "var(--sp-".concat(desktopPx, ", ").concat(desktopPx, "px)");
}
export function fixedSpacingValue(value) {
    if (!isSpacingToken(value)) return value;
    return DESKTOP_PX[value];
}
